import { createContext, useReducer, useState, useContext } from 'react'

export const VPNConnectLogContext = createContext() 

export const vpnConnectLogReducer = (state, action) => {
    switch (action.type) {
        case 'SET_VPNCONNECTLOG':
            return { vpnConnectLogs: action.payload }
        case 'CREATE_VPNCONNECTLOG':
            return { vpnConnectLogs: [action.payload, ...state.vpnConnectLogs] }
        case 'UPDATE_VPNCONNECTLOG':
            return { vpnConnectLogs: action.payload }
        case 'DELETE_VPNCONNECTLOG':
            return {
                ...state,
                vpnConnectLogs: {
                    ...state.vpnConnectLogs,
                    items: state.vpnConnectLogs.items.filter(
                        log => log._id !== action.payload
                    ),
                    totalCount: Math.max(
                        (state.vpnConnectLogs.totalCount || 0) - 1,
                        0
                    ),
                },
            };        default:
            return state
    }
}

export const VPNConnectLogContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(vpnConnectLogReducer, {
        vpnConnectLogs: {
            items: [],
            totalCount: 0,
            currentPage: 1,
            pageSize: 20,
            totalPages: 0,
        }
    })
    const [targetVPNConnectLog, setTargetVPNConnectLog] = useState(null)
    return (
      <VPNConnectLogContext.Provider 
        value={{ ...state, dispatch, targetVPNConnectLog, setTargetVPNConnectLog}}>
          { children }
      </VPNConnectLogContext.Provider>
    )
}

export const useVPNConnectLogContext = () => {
    const context = useContext(VPNConnectLogContext)
    if(!context) throw Error('useVPNConnectLogContext must be used inside an VPNConnectLogContextProvider')
    return context
}